import React from "react";
import { DatePicker, Space, Select } from "antd";

const CodReconcilationFilter = ({ filters, onFiltersChange }) => {
  return (
    <Space size="large" wrap>
      <div>
        Order Month :{` `}
        <DatePicker
          allowClear={false}
          picker="month"
          value={filters.startDate}
          onChange={(date) => {
            if (!date) {
              onFiltersChange({
                ...filters,
                startDate: undefined,
                endDate: undefined,
              });
              return;
            }

            const startOfMonth = date.startOf("month");
            const endOfMonth = date.endOf("month");

            onFiltersChange({
              ...filters,
              startDate: startOfMonth,
              endDate: endOfMonth,
            });
          }}
        />
      </div>
      <div>
        Remitted :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 120 }}
          allowClear
          onChange={(value) =>
            onFiltersChange({ ...filters, isRemittance: value })
          }
        >
          <Select.Option value="true">Yes</Select.Option>
          <Select.Option value="false">No</Select.Option>
        </Select>
      </div>
    </Space>
  );
};

export default CodReconcilationFilter;
